import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { InteriorSlide, SlideTitle } from './SlideShell';
import type { SlideProps } from './SlideShell';
import { closingQuestions } from '../../data/snakkerStory';
export function SlideClosing({
  onNavigate
}: SlideProps) {
  const [picked, setPicked] = useState<Record<string, string>>({});
  return <InteriorSlide surface data-id="element-358" data-mp="3jfqeq2r9xi1u">
      <SlideTitle eyebrow="Over to Ferring" data-id="element-359" data-mp="3jefc469kegcb">
        Where could REKOVELLE benefit from <span className="text-[var(--brand)]" data-id="element-360" data-mp="3o7rye9qrub1w">more interaction?</span>
      </SlideTitle>

      <div className="mt-[clamp(1.25rem,2.5vw,2.25rem)] grid min-h-0 flex-1 grid-cols-1 gap-[clamp(0.6rem,1.2vw,1.1rem)] md:grid-cols-3" data-id="element-361" data-mp="39ilqlxdvbcie">
        {closingQuestions.map((q, i) => <motion.fieldset key={q.title} initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.15 + i * 0.1,
        duration: 0.45
      }} className="flex min-h-0 flex-col rounded-2xl bg-white p-[clamp(1.1rem,2vw,1.85rem)] ring-1 ring-[var(--fg)]/[0.06]" data-id="element-362" data-mp="30he6qkc3me7u" data-mpi={i}>
            <legend className="sr-only" data-id="element-363" data-mp="3mnv5740n9isw">{q.title}</legend>
            <span className="font-mono text-[clamp(0.6rem,0.78vw,0.72rem)] tracking-[0.2em] text-[var(--muted)]" data-id="element-364" data-mp="5gt1mappkeso">0{i + 1}</span>
            <h3 aria-hidden="true" className="mt-2 text-[clamp(1.35rem,2.4vw,2.3rem)] font-extrabold uppercase leading-none tracking-[-0.04em] text-[var(--fg)]" data-id="element-365" data-mp="ihs613bs6az">
              {q.title}
            </h3>
            <div className="mt-auto flex flex-wrap gap-1.5 pt-[clamp(1rem,2vw,1.5rem)]" data-id="element-366" data-mp="33z8755gvxtot">
              {q.options.map(o => {
            const active = picked[q.title] === o;
            return <button key={o} type="button" aria-pressed={active} onClick={() => setPicked(p => ({
              ...p,
              [q.title]: active ? '' : o
            }))} className={`rounded-full px-3.5 py-1.5 text-[clamp(0.76rem,1vw,0.95rem)] font-semibold transition-[background-color,color,transform] duration-150 active:scale-[0.96] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand)] ${active ? 'bg-[var(--brand)] text-white' : 'bg-[var(--surface)] text-[var(--fg)] hover:bg-[var(--brand)]/10'}`} data-id="element-367" data-mp="3dui3pdoil8v7">
                    {o}
                  </button>;
          })}
            </div>
          </motion.fieldset>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 14
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.55,
      duration: 0.5
    }} className="mt-[clamp(1rem,2vw,1.75rem)] flex flex-shrink-0 flex-wrap items-end justify-between gap-6 border-t border-[var(--fg)]/10 pt-[clamp(1rem,1.8vw,1.5rem)]" data-id="element-368" data-mp="2vyk68h8sqg27">
        <div className="min-w-0 max-w-3xl" data-id="element-369" data-mp="l691zn7c4otw">
          <p className="text-[clamp(1.05rem,1.8vw,1.65rem)] font-extrabold leading-tight tracking-[-0.03em] text-[var(--fg)]" data-id="element-370" data-mp="l4xupdeokyy1">
            Give us the real brief. We’ll build around Ferring’s priorities, audiences and use cases.
          </p>
          <p className="mt-2 text-[clamp(0.85rem,1.3vw,1.2rem)] font-bold tracking-[-0.01em] text-[var(--brand)]" data-id="element-371" data-mp="20rjdx1k8v62w">
            Short. Interactive. Rewarding. Measurable.
          </p>
        </div>
        <button type="button" onClick={() => onNavigate?.('opening')} className="inline-flex flex-shrink-0 items-center gap-2 rounded-full bg-[var(--brand)] px-[clamp(1.2rem,2vw,1.8rem)] py-[clamp(0.7rem,1.1vw,1rem)] text-[clamp(0.7rem,0.9vw,0.85rem)] font-bold uppercase tracking-[0.14em] text-white shadow-sm transition-[background-color,transform] duration-150 hover:bg-[var(--fg)] active:scale-[0.97] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand)] focus-visible:ring-offset-2" data-id="element-372" data-mp="1qxj80xh51wt4">
          Let’s explore the next Snak
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-373" data-mp="32cg06g8md24p" />
        </button>
      </motion.div>
    </InteriorSlide>;
}